<template>
  <div class="layout-padding">
    <!-- 查詢 -->
    <q-card>
      <div class="row col-12 justify-center">
        <q-toolbar class="text-blue-8">
          <q-avatar>
            <q-icon name="fas fa-tasks"></q-icon>
          </q-avatar>
          <q-toolbar-title class="text-bold text-primary">
            工程進度查詢
          </q-toolbar-title>
        </q-toolbar>
        <div class="q-ml-xs col-12 col-md-5">
          <q-select class="q-required" outlined use-input clearable v-model="search.contObject" @input="searchCord()" :options="contOptions" @filter="(val,update,abort) => filterFn(val,update,abort,'cont')" label="工程編號/工程名稱">
          </q-select>
        </div>
        <div class="col-12 col-md-5">
          <q-select outlined use-input clearable v-model="search.cordNo" @input="filterCord()" :options="cordOptions" @filter="(val,update,abort) => filterFn(val,update,abort,'cord')" label="訂單編號">
          </q-select>
        </div>
        <!-- 擺放按鈕區 -->
        <q-card-actions class="justify-center">
          <q-btn flat push color="primary" icon-right="clear" label="清除" style="box-shadow:none;margin:0px" @click="clear()"></q-btn>
        </q-card-actions>
      </div>
    </q-card>
    <!-- 查詢結果 -->
    <q-page>
      <q-toolbar class="text-primary" v-show="orderFlag">
        <q-avatar>
          <q-icon name="fas fa-poll"></q-icon>
        </q-avatar>
        <q-toolbar-title>
          查詢結果
        </q-toolbar-title>
      </q-toolbar>
      <!-- 訂單相關日期 -->
      <template>
        <div class="row col-12 ">
          <div class="order-region col-md-6 col-12 q-pb-md" v-show="orderFlag">
            <q-toggle v-show="orderRegion.length > 0" class="col-6 q-mb-sm" v-model="expandFlag" @input="openExpand()" color="primary" label="合/開"/>
            <q-scroll-area style="height: 20em;" :content-style="contentStyle" :content-active-style="contentActiveStyle">
              <q-list class="rounded-borders" bordered v-for="(c, index) in orderRegion" :key="index">
                <q-expansion-item v-model="expanded[index]" :header-style="{backgroundColor: selected.cordNo === c.cordNo ? '#a2dce8': '' }" class="text-h5 text-weight-bold" icon="fas fa-clipboard" :label="c.name" header-class="text-blue-9">
                  <template v-slot:header class="text-center">
                    <q-item-section avatar>
                      <q-avatar icon="fas fa-clipboard" color="primary" text-color="white" />
                    </q-item-section>
                    <q-item-section>
                      <q-btn desc flat class="text-h5 col-10" align="left" push color="primary" style="box-shadow:none; font-size:1em; margin-bottom:0px;padding:0px" :label="c.cordNo" @click="openInsAndWind(c)"></q-btn>
                    </q-item-section>
                    <q-item-section side>
                      <div class="row items-center">
                        {{c.percentage}}
                        <q-menu content-class="q-pa-xs bg-primary text-white" touch-position>總出貨/總樘數</q-menu>
                      </div>
                    </q-item-section>
                  </template>
                  <q-item>
                    <q-item-section class="text-weight-bold text-black text-h6">
                      <q-item-label style="max-height: 8em;">
                        <div class="row col-12">
                          <div class="col-6">
                            產生日期：
                          </div>
                          <div class="col-6">
                            {{c.producedDate}}
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-6">
                            收件日期：
                          </div>
                          <div class="col-6">
                            {{c.receivedDate}}
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-6">
                            keyin完成日：
                          </div>
                          <div class="col-6">
                            {{c.keyinDate}}
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-6">
                            展開預定日：
                          </div>
                          <div class="col-6">
                            {{c.estimatedDate}}
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-6">
                            展開起始日：
                          </div>
                          <div class="col-6">
                            {{c.firstOpenedDate}}
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-6">
                            展開完成日：
                          </div>
                          <div class="col-6">
                            {{c.cofOpenedDate}}
                          </div>
                        </div>
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </q-expansion-item>
              </q-list>
            </q-scroll-area>
          </div>
          <div class="dseq-region col-md-6 col-12 q-pb-md">
            <!-- d_seq region 分納 -->
            <om-delivery-seq-view v-show="insFlag" :cordNo.sync="selected.cordNo" :insNo.sync="selected.insNo" :insFlag.sync="insFlag">
            </om-delivery-seq-view>
          </div>
        </div>
      </template>
      <!-- qty_table region 窗戶數量-->
      <om-qty-production-view v-show="winFlag" :cordNo.sync="selected.cordNo" :insNo.sync="selected.insNo" :winFlag.sync="winFlag">
      </om-qty-production-view>
      <!-- place QPageScroller at end of page -->
      <q-page-scroller position="bottom-right" :scroll-offset="80" :offset="[18, 18]">
        <q-btn fab icon="ion-rocket" color="orange" />
      </q-page-scroller>
    </q-page>
  </div>
</template>

<style>
</style>

<script>
import { commonMixin } from '@/common/js/mixins'
import Installment from '../components/Installment'
import QtyProduction from '../components/QtyProduction'

export default {
  name: 'objectmanage',
  mixins: [commonMixin],
  components: {
    'om-delivery-seq-view': Installment,
    'om-qty-production-view': QtyProduction
  },
  computed: {
    contentStyle () {
      return {
        backgroundColor: 'rgba(0,0,0,0.02)',
        color: '#555'
      }
    },

    contentActiveStyle () {
      return {
        backgroundColor: '#eee',
        color: 'black'
      }
    }
  },
  created () {
    // 取得 roleType
    this.roleType = this.$store.getters.getCurrentUserRoleType
  },
  mounted () {
    // 取得所有下拉選單
    setTimeout(() => this.getAllSelection(), 500)
  },
  data () {
    return {
      roleType: '',
      // 訂單查詢顯示開關
      orderFlag: false,
      // 分納顯示開關
      insFlag: false,
      // 窗號顯示開關
      winFlag: false,
      // 訂單開合
      expandFlag: false,
      expanded: [],
      search: {
        contObject: '',
        cordNo: ''
      },
      // 選取的物件
      selected: {
        cordNo: '',
        insNo: ''
      },
      // 工程選單
      allContOptions: [],
      contOptions: this.allContOptions,
      // 訂單選單
      allCordOptions: [],
      cordOptions: this.allCordOptions,
      // 訂單查詢結果
      orderRegion: [],
      allOrderRegion: []
    }
  },
  methods: {
    // 開合訂單
    openExpand () {
      this.expanded.forEach((o, index) => {
        this.expanded[index] = this.expandFlag
      })
    },
    openInsAndWind (cordObject) {
      // 開啟分納 區塊
      this.insFlag = true
      // 開啟窗號 區塊
      this.winFlag = true
      // 選取的訂單編號
      this.selected.cordNo = cordObject.cordNo
      // 清空已選取的分納號碼
      this.selected.insNo = ''
    },
    // 顯示訂單
    searchCord () {
      if (this.search.contObject) {
        this.get('getOrderRegionResult', { contNo: this.search.contObject.value }, r => {
          if (r.length > 0) {
            // 顯示窗格
            this.orderFlag = true
            // 顯示資料
            this.orderRegion = this.allOrderRegion = r
            // 預設全部收起
            this.expanded = []
            this.orderRegion.forEach(p => {
              this.expanded.push(false)
            })
            // 訂單編號選單
            this.allCordOptions = r.map(item => {
              return item.cordNo
            })
            this.allCordOptions.sort((a, b) => a - b)
            // 清除 查詢訂單編號欄位
            this.search.cordNo = null
          } else {
            this.message('此工程編號查無訂單')
            this.orderFlag = false
          }
        })
        // 重新查詢時隱藏 分納區塊 與 窗號區塊
        this.insFlag = false
        this.winFlag = false
      } else {
        this.clear()
      }
    },
    filterCord () {
      if (this.search.cordNo) {
        // 選取訂單號碼
        // 僅顯示該訂單編號資料
        this.orderRegion = this.allOrderRegion.filter(object => {
          return object.cordNo === this.search.cordNo
        })
        // 開啟
        this.expanded = []
        this.orderRegion.forEach(p => {
          this.expanded.push(true)
        })
      } else {
        // 清空訂單號碼
        // 還原該工程編號所有資料
        this.orderRegion = this.allOrderRegion
        // 預設全部收起
        this.expanded = []
        this.orderRegion.forEach(p => {
          this.expanded.push(false)
        })
      }
      // 隱藏分納 區塊
      this.insFlag = false
      // 隱藏窗號 區塊
      this.winFlag = false
      // 清除選取的訂單號碼與分納
      this.clearSelected()
    },
    // 篩選工程編號/名稱
    filterFn (val, update, abort, type) {
      // 工程編號filter
      if (type === 'cont') {
        if (val === '') {
          update(() => {
            this.contOptions = this.allContOptions
          })
          return true
        } else {
          update(() => {
            // to uppercase to match the contno/name then show LOV
            let needle = val.toUpperCase()
            this.contOptions = this.allContOptions.filter(function (item, index, array) {
              return item.label.toUpperCase().indexOf(needle) > -1
            })
          })
        }
      // 訂單號碼 filter
      } else if (type === 'cord') {
        if (val === '') {
          update(() => {
            this.cordOptions = this.allCordOptions
          })
          return true
        } else {
          update(() => {
            // to uppercase to match the contno/name then show LOV
            let needle = val.toUpperCase()
            this.cordOptions = this.allCordOptions.filter(function (item, index, array) {
              return item.toUpperCase().indexOf(needle) > -1
            })
          })
        }
      }
    },
    // 清空畫面上所有資料
    clear () {
      this.search.contObject = null
      this.search.contNo = ''
      this.insFlag = false
      this.orderFlag = false
      this.winFlag = false
      // 清除search 的訂單編號
      this.search.cordNo = null
      // 清除訂單編號選單
      this.allCordOptions = this.cordOptions = []
      this.clearSelected()
    },
    clearSelected () {
      // 清除選取的訂單號碼 與 分納
      this.selected.cordNo = ''
      this.selected.insNo = ''
    },
    getAllSelection () {
      // 取得 工程編號/工程名稱 選單
      let param = {
        userAccount: null
      }
      if (this.roleType === 'A') {
        param.userAccount = this.$store.getters.getUserAccount
      }
      this.get('getContSelection', param, r => {
        this.allContOptions = r
      })
    }
  }
}
</script>

<style>
 /* Note:a:hover MUST come after a:link and a:visited in the CSS definition in order to be effective.
 a:active MUST come after a:hover in the CSS definition in order to be effective. */
  a.link_mission  {
    text-decoration:none;
    color:blue;
  }
  a:link.link_mission  {
    text-decoration:underline;
  }
  a:visited.link_mission  {
    text-decoration:underline;
    color:purple;
  }
  a:hover.link_mission  {
    /* 當滑鼠經過超連結時，超連結往右下位移1像素且為桃紅色*/
    position: relative;
    top: 1px;
    left: 1px;
    color: #fc3a63;
    text-decoration:underline;
  }
  a:hover.link_mission  {
    /* 當滑鼠經過超連結時，超連結往右下位移1像素且為桃紅色*/
    position: relative;
    top: 1px;
    left: 1px;
    color: #fc3a63;
    text-decoration:underline;
  }
  .q-select__input--padding {
    min-width: 10px!important;
    text-transform: uppercase;
  }
  .close-icon {
    box-shadow: none;
    margin-bottom: 0px;
  }
  .searchBtn {
    width:100px;
  }

  /* 基本表格設定 */
.rwdTable {
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 5px;
}

.rwdTr, .rwdTitle_gorup {
  display: table-row;
  /* border-bottom: 2px solid; */
}

.rwdTh, .rwdTd {
  display: table-cell;
  vertical-align: top;
  text-align: center;
  padding: 5px 10px;
}

/* 表格單雙行顏色變化 */
.rwdTr:nth-of-type(odd), .rwdTitle_gorup:nth-of-type(odd) {
  background-color: #eaeaea;
}

/* 表頭背景藍色 */
.rwdTh {
  background-color: #0a7eb8;
  color: #ffffff;
}
@media (max-width: 767.98px) {
  /* 增加外框線 */
  .rwdTable{
    border: 1px solid #0a7eb8;
  }

  /* 將表格中間的空間刪掉 */
  .rwdTable {
    border-spacing: 0px;
  }

  /* 隱藏表頭列 */
  .rwdTr:first-of-type {
    display: auto;
  }
  .rwdTd {
    display: table;
    padding: 2;
  }

  .rwdTd:before{
    content: attr(data-th);
    display: table-cell;
    font-weight: bold;
    color: #fff;
    padding: 3px 10px;
    white-space: nowrap;
    text-align: center !important;
    width: 40px;
    background-color: #0a7eb8;
    vertical-align: top;
    font-size: 18px;
    min-width: 160px;
  }

  .rwdTd span{
    padding: 3px 10px;
    display: inline-block;
    font-size: 16px;
  }

  .rwdTr:nth-of-type(odd), .rwdTitle_gorup:nth-of-type(odd) {
    background-color: #e8f6ff;
  }

  /* 增加表格之外框線 */
  .q-table{
    border: 1px solid blue;
    min-width: 300px;
  }

  /* 將表格中間的空間刪掉 */
  .q-table {
    border-spacing: 0px;
  }
  .q-table th {
    opacity: 0;

  }
  /* 移除最上方表頭 */
  .q-table thead {
    display: none;
  }

  .q-table tbody td {
    font-size:16px;
    text-align:left;
    width: -webkit-fill-available;
    /* 讓過長資訊折行 */
    white-space: normal;
    min-width: 80px;
    max-width: 315px;
    overflow: hidden;
  }
  /* 設定orderRegion與d_seqRegion區塊"無"間格*/
  .order-region {
    padding-right: 0em !important;
  }
  .dseq-region {
    padding-left: 0em !important;
  }
}
/* 設定orderRegion與d_seqRegion區塊間格*/
.order-region {
    padding-right: 1.5em;
}
.dseq-region {
    padding-left: 1.5em;
}
.q-table th {
  background-color: #0a7eb8;
  color: #ffffff;
}

.q-icon.on-right {
  margin:0px;
}
 /* 必填外框設定 */
.q-required .q-field__control:before {
  border: 1px solid red !important;
  border-radius: 5px;
}
.q-required .q-field__control:hover:before {
  border: 1px solid black !important;
}
</style>
